var environment = (function () {
    return {
        //baseUrl: 'https://equipo.investel.es',
        //baseUrl: 'https://apitest.invesfleet.com',
        //baseUrl: 'https://appbeta.investel.es', 
        baseUrl: 'http://localhost:55401', 
        zohoUrl: 'https://api.investel.es/zoho',
        legacyBaseUrl: 'https://www.invesfleet.com/invesfleet/ws/INVESTEL/legacyConnect.asmx',
        //legacyBaseUrl: 'http://localhost:50785/WS/INVESTEL/legacyConnect.asmx',
        messagingBaseUrl: 'https://localhost:44352'
        //messagingBaseUrl: 'https://signaltest.invesfleet.com'
    };
})();

